import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CohortEntity } from '../../services/cohort.service';

@Component({
  selector: 'dcc-bulk-cohort-add',
  templateUrl: './bulk-cohort-add.component.html',
  styleUrls: ['./bulk-cohort-add.component.scss'],
})
export class CohortBulkImportComponent {
  @Output() bulkEntitiesEvent: EventEmitter<CohortEntity[]> =
    new EventEmitter();
  serialNumbersString = '';
  groupIdsString = '';

  constructor(private activeModal: NgbActiveModal) {}

  next(): void {
    let bulkEntities = [];
    if (this.serialNumbersString) {
      bulkEntities = this.serialNumbersString
        .split(/[,\s]+/)
        .map((s) => s.trim())
        .filter((s) => s.length > 0)
        .map((s) => ({ id: s, type: 'device' }) as CohortEntity);
    }

    if (this.groupIdsString) {
      bulkEntities = bulkEntities.concat(
        this.groupIdsString
          .split(/[,\s]+/)
          .map((s) => s.trim())
          .filter((s) => s.length > 0)
          .map((s) => ({ id: s, type: 'group' }) as CohortEntity),
      );
    }

    this.bulkEntitiesEvent.emit(bulkEntities);
    this.close();
  }

  close(): void {
    this.activeModal.close();
  }
}
